import { render, staticRenderFns } from "./AdsLayout.vue?vue&type=template&id=bdced4b4&scoped=true&"
import script from "./AdsLayout.vue?vue&type=script&lang=ts&"
export * from "./AdsLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AdsLayout.vue?vue&type=style&index=0&id=bdced4b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdced4b4",
  null
  
)

export default component.exports